const underlines = document.querySelectorAll('.hightlight-title u');
const imageWrappers = document.querySelectorAll('.image-wrapper');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      if (entry.target.tagName === 'U') {
        entry.target.classList.add('highlighted');
      }

      if (entry.target.classList.contains('image-wrapper')) {
        entry.target.classList.add('seen');
      }
    }
  });
}, {
  threshold: 0.75
});

underlines.forEach(u => observer.observe(u));

imageWrappers.forEach(wrapper => observer.observe(wrapper));
